import httpClient from '../../api/httpClient'

const defaultState = {
  current: 1,
  size: 1,
  last: 1,
  total: 1,
  cache: [],
  nextPageUrl: null,
  prevPageUrl: null,
  params: {},
}

const normalize = ({ current_page, per_page, last_page, total, cache, params = {}, next_page_url = null, prev_page_url = null }) => ({
  current: current_page,
  size: per_page,
  last: last_page,
  total: total,
  cache: [...cache, current_page],
  params,
  nextPageUrl: next_page_url,
  prevPageUrl: prev_page_url,
})

const setCurrentPage = ({ pagination, page, commit, url, params, client = httpClient }) => {
  const isFiltered = Object.keys(params).find((key) => key !== 'page' && pagination.params && pagination.params[key] !== params[key])
  if (isFiltered) {
    page = 1
    pagination.cache = []
    params.page = 1
  }
  if (page < 1 || page > pagination.last) return
  if (pagination.params.url === url && pagination.cache.includes(page)) {
    commit('update', { path: 'pagination', value: { ...pagination, current: page } })
    return Promise.resolve()
  }
  return client
    .get(url, { params })
    .then((res) => {
      delete params.page
      if (!res.data.current_page) {
        res.data.current_page = page
      }
      commit('update', {
        path: 'pagination',
        value: Paginate.normalize({ ...pagination, ...res.data, params: { ...params, url } }),
      })
      return Promise.resolve(res)
    })
    .catch((err) => Promise.reject(err))
}

export const Paginate = { defaultState, normalize, setCurrentPage }
